import { ReactNode, useEffect } from "react";
import Clarity from "@microsoft/clarity";

const { REACT_APP_CLARITY_PROJECT_ID } = process.env;

interface ClarityProviderProps {
  children: ReactNode;
}

const ClarityProvider = ({ children }: ClarityProviderProps) => {
  useEffect(() => {
    if (REACT_APP_CLARITY_PROJECT_ID)
      Clarity.init(REACT_APP_CLARITY_PROJECT_ID);
  }, []);

  return <>{children}</>;
};

export { ClarityProvider };
